import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CopyToClipboard from "react-copy-to-clipboard";
import { useEffect, useState } from "react";
import { GetExceptionsDetails } from "../../types/DocDistroCustomExceptionModel";
import { GetExceptionDetails } from "../../api/downstreamSummaryApi/downstreamSummaryApi";
import LocalStorageUtil from "../../utils/localStorage";
import { appSettings } from "../../config/appSetting";

interface CopyToClipboardProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  selectedData: any;
}

const CopyToClipboardPopup: React.FC<CopyToClipboardProps> = ({
  isOpen,
  onClose,
  title,
  selectedData,
}) => {
  const [_copytoClipboard, set_CopytoClipboard] = useState(false);// NOSONAR
  const [exceptionData, setExceptionData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [isButtonShow, setIsButtonShow] = useState<boolean>(false);

  //Copy the exception data to the clipboard
  const handleCopyToClipboard = () => {
    set_CopytoClipboard(true);
  };

  //Call the getExceptionData function when the dialog box is opened
  useEffect(() => {
    if (isOpen) {
      getExceptionData();
    }
  }, [isOpen]);

  const getExceptionData = async () => {
    setLoading(true);
    try {
      const parameters: GetExceptionsDetails = {
        Fromdate: undefined,
        Todate: undefined,
        NoOfRecords: 25,
        CurrentPage: 1,
        SortColumn: "",
        SortOrder: 0,
        TotalRecords: 0,
        IsExportToExcel: true,
        Timezone: appSettings.timezone,
        ContextName: LocalStorageUtil.getItem("contextName")?.toString(),
        Pagename: "",
        SearchTerm: selectedData.DownloadFileName,
        GetExceptionDetails: undefined,
        IsFromDownStream: true,
      };
      const response = await GetExceptionDetails(parameters);
      if (response.getexceptionDetails.length === 0) {
        setExceptionData("No Exception Details Found");
        setIsButtonShow(false);
      } else {
        setIsButtonShow(true);
        setExceptionData(response.getexceptionDetails);
        return response;
      }
    } catch (error) {
      console.error("Error in Exception Details fetching", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  //Return the Dialog box with the exception data
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        style: {
          height: "75%",
          width: "60%",
        },
      }}
    >
      <DialogTitle
        style={{
          backgroundColor: "var(--primary-color)", // Set the background color of the dialog title
        }}
      >
        <div
          className="col-sm-12"
          style={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
          }}
        >
          <div
            className="col-sm-11"
            style={{
              display: "flex",
              alignItems: "left",
              gap: "10px",
              color: "var(--aggrid-text-color)",
            }}
          >
            {title}
          </div>
          <div
            className="col-sm-1"
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "right",
            }}
          >
            {" "}
            <Tooltip title="Close">
              <IconButton
                onClick={onClose}
                style={{
                  cursor: "pointer",
                  alignItems: "flex-end",
                  color: "var(--aggrid-text-color)",
                  width: "20px",
                }}
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <TextField
            multiline
            aria-label="minimum height"
            maxRows={35}
            style={{ width: "95%", overflow: "auto", margin: "10px" }}
            value={JSON.stringify(exceptionData, null, 2)}
            aria-readonly
            InputProps={{
              style: {
                backgroundColor: "var(--aggrid-background-color)",
                border: "1px solid #ccc",
                font: "menu",
                fontFamily: "monospace",
              },
            }}
          />
        )}
      </DialogContent>
      <DialogActions>
        {isButtonShow && (
          <CopyToClipboard
            text={JSON.stringify(exceptionData, null, 2)}
            onCopy={handleCopyToClipboard}
          >
            <Button
              style={{
                textTransform: "none",
                borderRadius: "0px",
                backgroundColor: "var(--button-background-color)",
                color: "var(--button-color)",
                fontSize: "11px",
                padding: "5px 12px",
                border: "1px solid #144979",
                margin: "0 5px 5px 5px",
                whiteSpace: "white-space",
                height: "3.5vh",
              }}
            >
              Copy to clipboard
            </Button>
          </CopyToClipboard>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default CopyToClipboardPopup;
